module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_CS-82c4c834c7f47b1b6a12ae4e082b18fd.svg";